import * as e from "react";
import r from "../lib/IconBase.es.js";
import t from "../defs/EnvelopeSimple.es.js";
const o = e.forwardRef((m, p) => /* @__PURE__ */ e.createElement(r, { ref: p, ...m, weights: t }));
o.displayName = "EnvelopeSimpleIcon";
const i = o;
export {
  i as EnvelopeSimple,
  o as EnvelopeSimpleIcon
};
